import React, { useEffect } from "react";
import get from "lodash/get";

import { connectedFilterChip, connectedFilterType } from "./connectedFilterChip";

import { BoolChip } from "./Chips/BoolChip";
import { DateChip } from "./Chips/DateChip";
import { SelectChip } from "./Chips/SelectChip";
import { TextChip } from "./Chips/TextChip";
import { RangeChip } from "./Chips/RangeChip";
import { Pressable, Popover } from "~/native-ui";

const chipTypes = {
    text: { field: TextChip },
    select: { field: SelectChip, props: { closeOnUpdate: true, } },
    number: { field: RangeChip },
    select_many: { field: SelectChip, props: { closeOnUpdate: true, multiSelect: true } },
    textarea: { field: TextChip, props: { multiline: true } },
    // wysiwyg: { field: TextField, props: { multiline: true } },
    wysiwyg: { field: TextChip, props: { multiline: true } },
    bool: { field: BoolChip, props: { closeOnUpdate: true, }  },
    belongs_to: { field: SelectChip, props: { closeOnUpdate: true, }  },
    belongs_to_many: { field: SelectChip, props: { closeOnUpdate: true, multiSelect: true } },
    date: { field: DateChip, props: { } },
    datetime: { field: DateChip, },
    time: { field: DateChip, },
    file: { field: TextChip, },
    image: { field: TextChip },
};


const getChip = (type) => {
    return get(chipTypes, type) ?? chipTypes.text
}

export const FilterChip = connectedFilterChip(
    React.memo(
        React.forwardRef((props, ref) => {
            const {filter, filterValue, active, onPress, canDelete = active,} = props,
                {onDelete, trans} = props,
                {title, type} = filter,
                {field: Chip, props: chipProps} = getChip(type);

            const buttonProps = {
                ...chipProps,
                onPress,
                trans,
                title,
                active,
                filterValue,
                type,
                name: filter.name,
                variant: "outline",
                onDelete, canDelete,
                modelId: props.modelId,
                buttonProps: {
                    rounded: "full",
                }
            }

            return <Chip {...buttonProps} />
        })
    )
)

export const WithFilterChip = (Component) => connectedFilterType(React.memo((props) => {
    const { updateFilterOrder, onLayout, filterType, onChange: onChangeProp,  ...filterProps } = props;
    const [isOpen, setIsOpen] = React.useState(false);

    const updateFilterOrderRef = React.useRef(updateFilterOrder);
    updateFilterOrderRef.current = updateFilterOrder;


    const handleOpen = React.useCallback(() => {
        setIsOpen(true);
    }, [])


    const handleClose = React.useCallback(() => {
        setIsOpen(false);
        updateFilterOrderRef.current();
    }, []);


    const onChangeRef = React.useRef(onChangeProp);
    onChangeRef.current = onChangeProp;
    const onChange = React.useCallback((...args) => {
        onChangeRef.current?.(...args);
        if (getChip(filterType).props?.closeOnUpdate) handleClose();
    }, [filterType, handleClose]);


    const renderTrigger = (({ref, ...triggerProps}) => {
        return (
            <Pressable {...triggerProps} ref={ref}>
                <FilterChip name={props.name} modelId={props.modelId} {...triggerProps} />
            </Pressable>
        )
    });


    return (
        <Popover trigger={renderTrigger} onClose={handleClose} onOpen={handleOpen} isOpen={isOpen}>
            <Popover.Content>
                <Popover.Arrow height={10} width={10} />
                <Popover.Body>
                    <Component autoApplyFilter={false} vertical { ...filterProps } onChange={onChange} defaultCreatedAt={getChip(filterType).props?.closeOnUpdate ? undefined : 0} />
                </Popover.Body>
            </Popover.Content>
        </Popover>
    )
}));